export const FULL_DAY_PASS_TITLE = 'Full Day Pass';
export const FULL_DAY_PASS_PROMO_DESC = 'Full Day Waterpark Pass';
export const HALF_DAY_PASS_TITLE = 'Half Day Pass';
export const HALF_DAY_PASS_PROMO_DESC = 'Half Day Waterpark Pass';

export const SUMMARY_AMOUNT_DUE = 'Amount Due or Due at check-in';
export const SUMMARY_AMOUNT_DUE_AT_CHECKIN = 'Due at check-in';
export const SUMMARY_AMOUNT_PAYED = 'Amount Paid or Deposit Paid';
export const SUMMARY_DEPOSIT_PAYED = 'Deposit Paid';
export const SUMMARY_PAID_WITH = 'Paid With';
export const SUMMARY_PACKAGES = 'Packages';
export const SUMMARY_PACKAGES_TOTAL = 'Package Total';
export const SUMMARY_ADITIONAL_PACKAGE_TITLE = 'Additional Package Title';
export const SUMMARY_NEW_PACKAGES = 'New';
export const SUMAMRY_PACKAGES_AMOUNT = 'Package Amount';

export const RESORT_FEE =
  'The Resort Fee includes services that are often charged individually, including water park amenities life jackets and towels, resort-wide wireless internet, virtual concierge service, in-room amenities such as a coffee maker and mini-fridge, and perks unique to Great Wolf Lodge like complimentary arts & craft projects provided during select kids’ entertainment programs.';

//DAYPASS HEADER
export const NUMBER_OF_PASSES = '# of Day Passes';
export const VALID_ON = 'Valid On';
export const DAYPASS_DETAILS = '<AMOUNT> <TITLE>';

export const SUMMARY_PACKAGE_TITLE = '<AMOUNT> <TITLE>';

export const DAILY_PARKING_FEE = 'Self Parking: $<FEE>/day, paid upon arrival';

export const DAILY_PARKING_FEE_TITLE = 'Daily Parking Fee';
